import awsdk from 'awsdk';

// VIDEO
// PHONE

export const VisitModalityType = awsdk.AWSDKVisitModalityType;
export type VisitModalityType = typeof VisitModalityType;
